var map = {
	"./a_tool_0.png": "e895",
	"./a_tool_0_active.png": "7136",
	"./a_tool_1.png": "8472",
	"./a_tool_1_active.png": "7f8c",
	"./a_tool_2.png": "b9f2",
	"./a_tool_2_active.png": "60f7",
	"./a_tool_3.png": "47a2",
	"./a_tool_3_active.png": "f5d9",
	"./a_tool_4.png": "3065",
	"./a_tool_4_active.png": "9f4e",
	"./a_tool_5.png": "1ee8",
	"./a_tool_5_active.png": "9595",
	"./a_tool_6.png": "2a1c",
	"./a_tool_6_active.png": "7ff8",
	"./assign_0.png": "ecd3",
	"./assign_0_active.png": "9c17",
	"./assign_1.png": "2af8",
	"./assign_1_active.png": "8f24",
	"./assign_2.png": "8e46",
	"./assign_2_active.png": "e6de",
	"./assign_3.png": "9ff1",
	"./assign_3_active.png": "c18f",
	"./assign_4.png": "9f2f",
	"./assign_4_active.png": "292d",
	"./assign_5.png": "34b7",
	"./assign_5_active.png": "d1b5",
	"./assign_6.png": "fbf7",
	"./assign_6_active.png": "7465",
	"./axe_gold.png": "1966",
	"./axe_place.png": "f423",
	"./background.png": "cb54",
	"./detail.png": "ab44",
	"./elements.png": "35f1",
	"./header_logo.png": "55d4",
	"./intro_bg.png": "2946",
	"./intro_title.png": "59e5",
	"./kizhi_logo.png": "a3ee",
	"./m_bereza.png": "ed16",
	"./m_el.png": "2c1a",
	"./m_kamen.png": "3a88",
	"./m_osina.png": "12c7",
	"./m_sosna.png": "3631",
	"./master.png": "9dcc",
	"./materials_task.png": "ea5c",
	"./node_0.png": "0d04",
	"./node_1.png": "1774",
	"./node_2.png": "f5f3",
	"./node_3.png": "92e8",
	"./node_4.png": "9881",
	"./node_5.png": "6359",
	"./node_6.png": "6864",
	"./node_7.png": "3074",
	"./plotnik.png": "d317",
	"./structures_0.png": "6f02",
	"./structures_1.png": "8723",
	"./structures_2.png": "b75f",
	"./structures_3.png": "63ec",
	"./structures_4.png": "422a",
	"./structures_5.png": "a0bb",
	"./structures_6.png": "ca66",
	"./structures_7.png": "5685",
	"./task_bg.png": "c989",
	"./tools_0.png": "6552",
	"./tools_1.png": "0048",
	"./tools_2.png": "07c1",
	"./tools_3.png": "253b",
	"./tools_4.png": "2fa3",
	"./tools_5.png": "7e4d",
	"./tools_6.png": "2b42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95cd";